import React, { useContext, useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import ConsultaPergunta from '../../../../../lib/json/consultas/Perguntas.json'
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import { ConsultaAPI } from "../../../../../backend/ConsultaAPI";
import { useNavigate } from "react-router-dom";
import { ConsumoAPI_DELETE } from "../../../../../backend/ConsumoAPI";
import { SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { usePopUp } from "../../../../components/BootBox";

function formatarTipoResposta(row){
    var optionsTipoResposta = [
        {value: "T", text: 'Resposta Curta'}, 
        {value: "P", text: 'Parágrafo'},
        {value: "N", text: 'Númerico'}, 
        {value: "M", text: 'Multipla Escolha'},
        {value: "C", text: 'Caixas de Seleção'},
        {value: "L", text: 'Lista Suspensa'},
        {value: "A", text: 'Anexo'},
        {value: "D", text: 'Data'},
        {value: "H", text: 'Horário'},
        {value: "V", text: 'Valor Monetário'},
        {value: "I", text: 'Incremental'}
    ]

    return optionsTipoResposta.filter( item => item.value == row.value )[0].text
}

function ListaPergunta(){
    const navigate = useNavigate();
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const columns = [
        {
            Header: 'ID',
            accessor: 'Id',
        },
        {
            Header: 'Descrição',
            accessor: 'Descricao',
        },
        {
            Header: 'Tipo Resposta',
            accessor: 'TipoResposta',
            Cell: formatarTipoResposta
        }
    ];
    
    var [carregar, setCarregar] = useState(false);
    var [data, setData]   = useState([]);
    var consultaDefault  = ConsultaPergunta.consulta;

    useEffect(() => {
        loadListaPergunta();
    }, []);

    // Processa consulta do grid
    const loadListaPergunta = async () => {
        setCarregar(true);
        var retConsulta = await ConsultaAPI( consultaDefault );
        setData(retConsulta.data);
        setCarregar(false);
    }

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.Id}`)
    }
    
    const handleExcluir = async (row) => {
        const idRow = row.values.Id;
        const Mensagem = `Tem certeza que deseja excluir o registro ${idRow + ' - ' + row.values.Descricao}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(id) => {
        FechaBootBox()
        try {
            setCarregar(true);
            const rota = 'perguntas/' + id;
            const retConsumo = await ConsumoAPI_DELETE(rota);
            SucessoMsg(retConsumo.description);
            loadListaPergunta();
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    };

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Perguntas"/>
            </Col>
            <Col md="3" xs="12">
                <Form.Group as={Col} className="md-2" controlId="formGridBuscar">
                    <InputGroup size="md" className="mb-3">
                        <Button variant="outline-primary" type="submit" onClick={loadListaPergunta}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
        
        <Row>
            { data.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons= {[
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote"}, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger"}
                        ]}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaPergunta;